import { NavigateFunction } from 'react-router-dom';
import callToast from '../../components/blocks/ToastMessage/_parts/callToast/callToast';

export const executeErrorSequence = (errorMessage: unknown, catalogLink: string, navigate: NavigateFunction) => {
  console.error('Error: ', errorMessage);
  callToast({
    title: 'No related data',
    children: `It seems there is no corresponding services. Please, check our catalog below.`,
    variation: 'info',
  });
  navigate(catalogLink);
};
